const MS_IN_DAY = 24 * 60 * 60 * 1000;

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.m-holiday-hero__wrapper').forEach(initHolidayHero);
});

function initHolidayHero(wrapper) {
  const sectionId = wrapper.dataset.sectionId;
  const section = wrapper.closest('.m-holiday-hero') || document.querySelector(`#shopify-section-${sectionId}`);

  if (!sectionId || !section) return;

  setupVideo(section);
  setupCountdown(section);
  setupModal(section, sectionId);
}

function setupVideo(section) {
  const videoNodes = section.querySelectorAll('[data-js-holiday-hero-vimeo]');
  if (!videoNodes.length) return;

  const players = [];
  const playerStates = [];

  videoNodes.forEach((node, index) => {
    const player = new Vimeo.Player(node, { muted: true, loop: true });
    players[index] = player;
    playerStates[index] = { muted: true };

    player.on('loaded', () => {
      const container = node.closest('.m-holiday-hero__video-player');
      if (!container) return;

      const playButton = container.querySelector('.m-holiday-hero__video-button');
      const muteWrapper = container.querySelector('.m-holiday-hero__video-mute');
      const muteButton = container.querySelector('.js-holiday-hero-video-mute');
      const isAutoplay = container.dataset.autoplay === 'true';

      if (muteButton) {
        muteButton.dataset.index = index;
        muteButton.addEventListener('click', () => {
          toggleMute(players, index, section, playerStates);
        });
      }

      container.classList.add('m-holiday-hero__video-player--loaded');

      if (isAutoplay == 'true') {
        player.play().catch(() => {});
        container.classList.add('m-holiday-hero__video-player--playing');
        container.classList.remove('m-holiday-hero__video-player--paused');

        if (muteWrapper) muteWrapper.style.display = 'block';
        toggleMute(players, index, section, playerStates, true);
      }

      if (playButton) {
        playButton.style.display = 'flex';
        handlePlayPause(playButton, player, container, muteWrapper, index, players, section, playerStates);
      }
    });
  });
}

function handlePlayPause(button, player, container, muteWrapper, index, players, section, states) {
  const playIcon = button.querySelector('.m-holiday-hero__video-play-icon');
  const pauseIcon = button.querySelector('.m-holiday-hero__video-pause-icon');

  button.addEventListener('click', () => {
    player.getPaused().then((paused) => {
      if (paused) {
        player.play();
        container.classList.add('m-holiday-hero__video-player--playing');
        container.classList.remove('m-holiday-hero__video-player--paused');

        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = 'block';
        if (muteWrapper) muteWrapper.style.display = 'block';

        toggleMute(players, index, section, states, true);
      } else {
        player.pause();
        container.classList.remove('m-holiday-hero__video-player--playing');
        container.classList.add('m-holiday-hero__video-player--paused');

        if (playIcon) playIcon.style.display = 'block';
        if (pauseIcon) pauseIcon.style.display = 'none';
        player.setMuted(true);

        if (muteWrapper) muteWrapper.style.display = 'none';

        section.querySelectorAll('.js-holiday-hero-video-mute').forEach((btn) => {
          btn.classList.remove('is-active');
        });
      }
    });
  });
}

function toggleMute(players, activeIndex, section, states = [], forceUnmute = false) {
  const activeState = states[activeIndex] || { muted: true };
  const shouldMuteActive = forceUnmute ? false : !activeState.muted;

  players.forEach((player, index) => {
    if (!player) return;
    if (index === activeIndex) {
      const mute = shouldMuteActive;
      player.setMuted(mute);
      player.setVolume(mute ? 0 : 1);

      if (states[index]) states[index].muted = mute;
    } else {
      player.setMuted(true);
      player.setVolume(0);

      if (states[index]) states[index].muted = true;
    }
  });

  section.querySelectorAll('.js-holiday-hero-video-mute').forEach((button) => {
    const isActive = Number(button.dataset.index) === activeIndex;
    button.classList.toggle('is-active', isActive);
  });
}

function setupCountdown(section) {
  const trigger = section.querySelector('.js-holiday-hero-countdown-trigger');
  if (!trigger) return;

  const timerElement = trigger.querySelector('.m-holiday-hero__countdown-timer');
  const startDateStr = trigger.dataset.startDate;
  const dropTimeStr = trigger.dataset.dropTime || '10:00';
  const durationDays = Number(trigger.dataset.durationDays || 0);

  if (!timerElement || !startDateStr) return;

  const [hours = 10, minutes = 0] = dropTimeStr.split(':').map(Number);
  const baseDate = new Date(startDateStr);
  const startTimestamp = Date.UTC(baseDate.getUTCFullYear(), baseDate.getUTCMonth(), baseDate.getUTCDate(), hours + 5, minutes);

  const updateTimer = () => {
    const now = Date.now();

    for (let day = 0; day <= durationDays; day++) {
      const dropTimestamp = startTimestamp + day * MS_IN_DAY;

      if (dropTimestamp >= now) {
        const diff = dropTimestamp - now;
        const totalSeconds = Math.floor(diff / 1000);
        const hrs = Math.floor(totalSeconds / 3600);
        const mins = Math.floor((totalSeconds % 3600) / 60);
        const secs = totalSeconds % 60;

        timerElement.textContent = [hrs, mins, secs].map((n) => String(n).padStart(2, '0')).join(':');

        trigger.style.display = 'flex';
        return;
      }
    }

    trigger.style.display = 'none';
  };

  updateTimer();
  setInterval(updateTimer, 1000);
}

function setupModal(section, sectionId) {
  const trigger = section.querySelector('.js-holiday-hero-countdown-trigger');
  const modal = document.querySelector(`#holiday-hero-popup-${sectionId}`);

  if (!trigger || !modal) return;

  trigger.addEventListener('click', () => {
    populateModalWithDropInfo(modal);
    section.classList.add('m-holiday-hero--open');
    openHolidayModal(modal, trigger);
  });

  setupHolidayModalClose(modal, section);
}
